export default {
    'selectPage': {
        'login_user_name': 'Login User',
        'update_password': 'Change Password',
        'logout': 'Logout',
        'center_text': 'INFORMATION DIGITIZATION MANAGEMENT CENTER',
        'container_center': 'Customer Success · Embrace Change · Altruism and Win-Win Cooperation \n Diligence and Ownership · Continuous Self-Criticism · Openness and Humility',
        // Old password
        'old_password': 'Old Password',
        // Please enter old password
        'old_password_placeholder': 'Please enter old password',
        // Please enter password
        'password_placeholder': 'Please enter password',
        'password_format_error': 'Password must contain letters, numbers, 6-16 characters long',
        // New password
        'new_password': 'New Password',
        // Please enter new password
        'new_password_placeholder': 'Please enter new password',
        // Enter new password again
        'new_password_again': 'Enter New Password Again',
        // Please enter new password again
        'new_password_again_placeholder': 'Please enter new password again',
        // Cancel
        'btn_cancel': 'Cancel',
        // 进入 OWMS
        'btn_enter_owms': 'Enter OWMS',
        // Confirm
        'btn_confirm': 'Confirm',
        // Wuyou Global R&D Center
        'wyd_global_development_center': 'Global R&D Center of WYD',
        // You do not have permission to log in to this system
        'no_permission_login': 'You do not have permission to log in to this system',
        // Are you sure to logout the system?
        'logout_confirm': 'Are you sure to logout the system?',
        // Tip
        'tip': 'Tip',
        //选择仓库

        'select_warehouse': 'Select Warehouse',
        // Logout successful
        'logout_success': 'Logout successful',
        // New password cannot be the same as old password
        'new_password_same_old_password': 'New password cannot be the same as old password',
        // The two new passwords entered are inconsistent
        'new_password_not_same': 'The two new passwords entered are inconsistent',
        // Password changed successfully
        'update_password_success': 'Password changed successfully',
        // 请选择
        'select_placeholder': 'Please select',
    },
    login: {
        'center_text': 'DIGITAL INFORMATION MANAGEMENT CENTER',
        'container_center': 'Customer Success · Embrace Change · Altruism and Win-Win Cooperation · Diligence and Ownership · Continuous Self-Criticism · Openness and Humility',
        // Please enter username
        'username_placeholder': 'Account',
        'username_message': 'Please enter username',
        // Please enter password
        'password_placeholder': 'Password',
        'password_message': 'Please enter password',

        // Remember password
        'remember_password': 'Save password',
        // Login
        'btn_login': 'Login',
        // Please enter new password
        'new_password_placeholder': 'Please enter new password',
        // Enter new password again
        'new_password_again_placeholder': 'Enter new password again',
        // Change password
        'btn_update_password': 'Change password',
        // Please enter phone number
        'phone_placeholder': 'Please enter phone number',
        // Get verification code
        'get_valid_code': 'Get verification code',
        // Please enter verification code
        'valid_code_placeholder': 'Please enter verification code',
        // Back to login
        'btn_back_login': 'Back to login',
        // Confirm change
        'btn_confirm_update_password': 'Confirm change',
        // Password format is incorrect (must contain letters, numbers, 6-16 characters long)
        'password_format_error': 'Password format is incorrect (must contain letters, numbers, 6-16 characters long)',
        // The two passwords entered are inconsistent
        'new_password_not_same': 'The two passwords entered are inconsistent',
        // Phone number format is incorrect
        'phone_format_error': 'Phone number format is incorrect',
        // Login successful
        'login_success': 'Login successful',
        // Password changed successfully
        'update_password_success': 'Password changed successfully',
        // Phone number is incorrect
        'phone_error': 'Phone number is incorrect',
        // "Sent successfully!"
        'send_success': 'Sent successfully!',
        // This phone number has not sent verification code yet
        'phone_not_send_code': 'This phone number has not sent verification code yet',
        // Change successful
        'update_success': 'Change successful',
    },
    common:{
        btn_confirm: 'Confirm',
        btn_cancel: 'Cancel',
    }
}
